import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-7" }
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = { class: "col-5" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_7 = { class: "countries-list" }
const _hoisted_8 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "row align-items-center" }
const _hoisted_11 = { class: "col-7" }
const _hoisted_12 = { class: "subtitle" }
const _hoisted_13 = { class: "col-5" }
const _hoisted_14 = { class: "mt-3" }
const _hoisted_15 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_16 = { class: "countries-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_CountrySwitch = _resolveComponent("CountrySwitch")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.locationType) + " Countries", 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AppButton, {
            type: "primary-transparent",
            size: "md",
            class: "ms-auto add-country-button",
            disabled: !!_ctx.localSelectedSubregions.length,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLocationsSelection('country')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" + Add Country ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.localSelectedCounties.length < 2)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Please, add at least 2 countries to this " + _toDisplayString(_ctx.locationType) + ". ", 1))
          : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localSelectedCounties, ({ id, name, icon }) => {
            return (_openBlock(), _createElementBlock("li", {
              key: id,
              class: "countries-list-item"
            }, [
              _createVNode(_component_CountrySwitch, {
                id: id,
                name: name,
                checked: true,
                icon: icon,
                onSwitch: _ctx.switchLocalCountry
              }, null, 8, ["id", "name", "icon", "onSwitch"])
            ]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.showSubregionsSelection)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.locationType) + " Subregions", 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_AppButton, {
                type: "primary-transparent",
                size: "md",
                class: "ms-auto add-country-button",
                disabled: !!_ctx.localSelectedCounties.length,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLocationsSelection('subregion')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" + Add Subregion ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.localSelectedSubregions.length < 2)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Please, add at least 2 subregions to this " + _toDisplayString(_ctx.locationType) + ". ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localSelectedSubregions, ({ id, name, icon }) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: id,
                  class: "countries-list-item"
                }, [
                  _createVNode(_component_CountrySwitch, {
                    id: id,
                    name: name,
                    checked: true,
                    icon: icon,
                    onSwitch: _ctx.switchLocalSubregion
                  }, null, 8, ["id", "name", "icon", "onSwitch"])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}